import { ReactNode } from 'react';
import { Box, Text, Image } from '@mantine/core';
import classes from './PreviousDrawerButton.module.css';
import PlusIcon from '@assets/icons/arrow-left-previous.svg';

export const PreviousDrawerButton = (props: {
	children: ReactNode;
	onClick?: () => void;
}) => {
	return (
		<Box
			onClick={props.onClick}
			className={classes.previous}
		>
			<Image
				className={classes.iconPrevious}
				src={PlusIcon}
			/>
			<Box className={classes.spacerPreviousBtn} />
			<Text className={classes.previousText}>
				{props.children}
			</Text>
		</Box>
	);
};
